import React from 'react';
import type { EditorIconProps } from './EditorIconProps';

export const LlamaRedo = ({
  color = 'currentColor',
  size = 40,
  ...props
}: EditorIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g transform="translate(8, 10) scale(1.0)">
        <path
          d="M21.8501 7C22.4852 7 23 7.51967 23 8.16071C23 8.80176 22.4852 9.32143 21.8501 9.32143H6.67083C5.05813 9.32144 3.9839 9.87921 3.31264 10.6154C2.62559 11.369 2.27752 12.4012 2.3006 13.4746C2.34663 15.6118 3.82474 17.6786 6.67083 17.6786H13.1105C13.7456 17.6786 14.2604 18.1982 14.2604 18.8393C14.2604 19.4803 13.7456 20 13.1105 20H6.67083C2.38735 20 0.0706552 16.7274 0.00161279 13.5254C-0.032764 11.9293 0.481635 10.2917 1.62007 9.04304C2.77433 7.77708 4.48874 7.00001 6.67083 7H21.8501Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3828 2.3202C14.8724 1.78942 14.8724 0.92886 15.3828 0.398083C15.8932 -0.132694 16.7208 -0.132694 17.2312 0.398083L23.6172 7.03894C24.1276 7.56972 24.1276 8.43028 23.6172 8.96106L17.2312 15.6019C16.7208 16.1327 15.8932 16.1327 15.3828 15.6019C14.8724 15.0711 14.8724 14.2106 15.3828 13.6798L20.8447 8L15.3828 2.3202Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

LlamaRedo.displayName = 'LlamaRedo';
